import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-43" data-mp="e3n6tdlsvhuo">
      <div className="mx-auto max-w-5xl" data-id="element-44" data-mp="9crfmvp101a">
        <div className="mx-auto max-w-3xl text-center" data-id="element-45" data-mp="8be1br7g1ge">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-46" data-mp="57xstpmolprb">
            Un modo migliore di insegnare arte
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-navy sm:text-5xl" data-id="element-47" data-mp="3rgypmzzn8aar">
            Da Docente Sopraffatto a{' '}
            <span className="italic text-grape" data-id="element-48" data-mp="3diqzbax4478k">Guida Sicura.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-navy/60 sm:text-base" data-id="element-49" data-mp="3igakkus89ka0">
            Arte Pronta trasforma ore di pianificazione estenuante in un sistema
            «apri e insegna». Entra in ogni lezione con un piano chiaro,
            attività che incantano gli alunni e la sicurezza di chi ha già tutto
            sotto controllo.
          </p>
        </div>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-50" data-mp="1f8sf1fasz1dl">
          <div className="grid md:grid-cols-2" data-id="element-51" data-mp="1szx9m2zbd3h2">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-52" data-mp="1t2t8pumwdy73">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy/35" data-id="element-53" data-mp="1o36vvmazejyt">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-54" data-mp="10e4fsivzwz6f" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-navy/40" data-id="element-55" data-mp="wcsom8xh45w4">
                Il costo di partire da zero ogni giorno
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-56" data-mp="15ameb10qg1ab">
                IL VECCHIO MODO
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-57" data-mp="2gqt7nhud4uwr">
                Stancante, improvvisato, mai finito.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-58" data-mp="2oqplgrjmwzb1">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white/80 px-4 py-3 text-sm text-navy/60" data-id="element-59" data-mp="2srsy756dyf81">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/30" aria-hidden="true" data-id="element-60" data-mp="2xsgplryj0y2s" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-61" data-mp="254kpsednuq1s">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-teal text-white" data-id="element-62" data-mp="2a231gcj2bjdh">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-63" data-mp="2f0nv1t3t74sy" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-teal" data-id="element-64" data-mp="2jsxrzt3cd54q">
                Il sistema Arte Pronta
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-65" data-mp="1rbv4yd9vbr69">
                CON ARTE PRONTA
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-66" data-mp="1jru0rbfl9yrz">
                La tua nuova realtà.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-67" data-mp="19u63adqlmd64">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-navy-light px-4 py-3 text-sm font-medium text-navy" data-id="element-68" data-mp="19sbiczfbul21">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-69" data-mp="10t7xbpwlnvkw" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-navy/5 bg-cream px-6 py-4 text-center text-xs text-navy/50" data-id="element-70" data-mp="r3ex1l1wr2vy">
            Un sistema completo per pianificare meno e insegnare con più senso.
          </p>
        </div>
      </div>
    </section>;
}